'use client';

import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { PageContainer } from './PageContainer';

type LayoutProps = {
  children: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  return (
    <Box height="100vh" bg="neutral.background">
      <PageContainer>{children}</PageContainer>
    </Box>
  );
}
